__turbopack_context__.v({
  "bannerImage": "SingleBlogHeroSection-module-scss-module__8slila__bannerImage",
  "cardImage": "SingleBlogHeroSection-module-scss-module__8slila__cardImage",
  "container": "SingleBlogHeroSection-module-scss-module__8slila__container",
  "header": "SingleBlogHeroSection-module-scss-module__8slila__header",
  "imageWrapper": "SingleBlogHeroSection-module-scss-module__8slila__imageWrapper",
  "root": "SingleBlogHeroSection-module-scss-module__8slila__root",
  "socialButton": "SingleBlogHeroSection-module-scss-module__8slila__socialButton",
  "socialIcon": "SingleBlogHeroSection-module-scss-module__8slila__socialIcon",
  "socials": "SingleBlogHeroSection-module-scss-module__8slila__socials",
  "title": "SingleBlogHeroSection-module-scss-module__8slila__title",
});
